import React, { useState } from "react";
import {auth, db} from "./firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import {doc, setDoc} from "firebase/firestore"; 
import {X, UserPlus} from "lucide-react"

function Register({onRegisterSuccess, onSwitchToLogin, onBack}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const registerUser = async (e) => {
    e.preventDefault();
  
    const cleanEmail = email.trim().toLowerCase();
    const cleanPassword = password.trim();

    setError("");
    setLoading(true);

    // 🔒 Frontend validation
    if (!cleanEmail) {
      alert("Email cannot be empty.");
      return;
    }

    if (!cleanPassword) {
      alert("Password cannot be empty.");
      return;
    }

    if (cleanPassword.length < 6) {
      alert("Password must be at least 6 characters.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(cleanEmail)) {
      alert("Please enter a valid email address.");
      return;
    }

    // 🔗 Backend register
    try {
      //firebase create user
      const userCredential = await createUserWithEmailAndPassword(auth,cleanEmail,cleanPassword);
      const user = userCredential.user;
      
      //save user to firestore database
      await setDoc(doc(db, "users", user.uid), {
        email: user.email,
        createdAt: new Date(),
        preferences: {
            budget: 0, // Default values
            store: "all"
        }
      });

      //notify the parent (welcome.js) to log them in 
      if (onRegisterSuccess) onRegisterSuccess();

    } catch (err) {
      console.error("Register Error:", err);
      
      //clean up firebase if error messages
      let msg = "Registration failed. Please try again.";
      if (err.code === "auth/email-already-in-use") msg = "This email is already registered.";
      if (err.code === "auth/invalid-email") msg = "Please enter a valid email address.";
      if (err.code === "auth/weak-password") msg = "Password should be at least 6 characters.";

      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    // ✨ This outer div makes it a POPUP MODAL (Fixed, Inset-0, Z-Index)
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn">
      
      {/*Modal Card */}
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md mx-4 p-8 relative animate-slideUp">
        
        {/* Back Button */}
        <button
          onClick={onBack}
          className="absolute top-5 right-5 text-gray-400 hover:text-gray-600 transition-colors bg-gray-100 p-2 rounded-full hover:bg-gray-200"
        >
          <X size={20}/>
        </button>

        {/* Icon */}
        <div className="mx-auto h-16 w-16 rounded-2xl bg-[#FFF3E0] flex items-center justify-center mb-6">
          <UserPlus className="w-8 h-8 text-[#FF8C42]" />
        </div>

        <h2 className="text-3xl font-extrabold text-center text-[#5A3E2B] mb-2">
          Create Account
        </h2>
        <p className="text-center text-gray-500 text-sm mb-6">
          Start saving your grocery history today
        </p>

        {error && (
          <div className="bg-red-50 text-red-600 px-4 py-3 rounded-xl text-sm text-center mb-4 border border-red-100">
            {error}
          </div>
        )}

        <form onSubmit={registerUser} className="space-y-4">
          <div>
            <label className="text-[#5A3E2B] font-semibold text-sm ml-1">Email</label>
            <input
              type="email"
              className="w-full mt-1 px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#FF8C42] focus:border-transparent outline-none transition-all"
              placeholder="name@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div>
            <label className="text-[#5A3E2B] font-semibold text-sm ml-1">Password</label>
            <input
              type="password"
              className="w-full mt-1 px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#FF8C42] focus:border-transparent outline-none transition-all"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-xl bg-[#FF8C42] text-white font-bold shadow-lg hover:shadow-xl 
                       hover:scale-[1.01] transition-all
                       disabled:opacity-70"
          >
            {loading ? "Creating Account..." : "Sign Up"}
          </button>
        </form>

        <p className="text-center mt-6 text-gray-600">
          Already have an account?{" "}
          <button
            onClick={onSwitchToLogin}
            className="text-[#FF8C00] font-bold hover:underline"
          >
            Log In
          </button>
        </p>
      </div>
    </div>
  );
}

export default Register;
